module.exports = __webpack_public_path__ + "img/ciabatta.527c97dc.jpg";